import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import Cookies from "js-cookie";
import React from 'react';
import {Navigate, useLocation} from 'react-router-dom';
import {useAuth} from '../../context/AuthContext';

const ProtectedRoute = ({children, allowedRoles = [], allowedPaths = []}) => {
	const {user, loading, firstAdmin} = useAuth();
	const location = useLocation();

	if (loading) {
		return (
			<Box
				sx={{
					display: 'flex',
					justifyContent: 'center',
					alignItems: 'center',
					height: '100vh',
					width: '100%'
				}}
			>
				<CircularProgress/>
			</Box>
		);
	}

	const currentPath = location.pathname;

	const firstAdminCreated = Cookies.get("first_admin_created");

	if (!user) {
		if (!firstAdmin && !firstAdminCreated) {
			return <Navigate to="/add-admin" replace/>;
		}

		if (currentPath === '/app/login/') {
			return children;
		}
		return <Navigate to="/app/login/" replace/>;
	} else if (user.status === 'BLOCKED') {
		Cookies.remove("auth");
		Cookies.remove("simpalsid.lang");
		return <Navigate to="/app/login/" state={{message: 'blocked'}} replace/>;
	}

	const userRole = user.role?.toLowerCase();

	if (currentPath === '/app/login/') {
		if (userRole === 'user') {
			return <Navigate to="/acps/" replace/>;
		} else if (userRole === 'admin' || userRole === 'super_admin' || userRole === 'fiscal_officer') {
			return <Navigate to="/" replace/>;
		}
		return children;
	}

	if (userRole === 'user') {
		if (currentPath.startsWith('/acps/') || currentPath === '/app/login/') {
			return children;
		}
		return <Navigate to="/acps/" replace/>;
	}

	if (userRole === 'admin' || userRole === 'super_admin' || userRole === 'fiscal_officer') {
		return children;
	}

	if (currentPath.startsWith('/acps/') || currentPath === '/app/login/') {
		return children;
	}
	return <Navigate to="/acps/" replace/>;
}


export default ProtectedRoute;
